import { PhaseType } from '@schema/phase'
import {
  InitiativeCreationStep,
  initiativeCreationSteps,
} from '../../shared/workflow'
import { CreationGuide } from '../blocks/CreationGuide'
import { useEffect, useMemo, useState } from 'react'
import { AmenitiesSelectionGrid } from '@app/pages/dashboard/initiative/shared/forms/amenities/AmenitiesSelectionGrid'
import { useInitiativeAutoSave } from '@app/pages/dashboard/initiative/shared/useInitiativeAutoSave'
import type { InitiativeWithId } from '@app/pages/dashboard/initiative/shared/initiativeTypes'

const CURRENT_STEP = initiativeCreationSteps.amenities

export const AmenitiesStep = ({
  initiative,
  selectedPhaseType,
  completeStep,
  uncompleteStep,
}: {
  initiative: InitiativeWithId
  selectedPhaseType: PhaseType
  completeStep: (step: InitiativeCreationStep) => void
  uncompleteStep: (step: InitiativeCreationStep) => void
}) => {
  const [selectedIds, setSelectedIds] = useState<number[]>(() =>
    (initiative.amenities ?? []).map((a) => a.id),
  )

  useEffect(() => {
    setSelectedIds((initiative.amenities ?? []).map((a) => a.id))
  }, [initiative.amenities])

  const payload = useMemo(
    () => ({
      amenities: selectedIds.map((id) => ({ id })),
      onboardingStep: CURRENT_STEP,
    }),
    [selectedIds],
  )

  useInitiativeAutoSave(initiative.id, payload)

  useEffect(() => {
    if (selectedIds.length > 0) {
      completeStep(CURRENT_STEP)
    } else {
      uncompleteStep(CURRENT_STEP)
    }
  }, [selectedIds.length, completeStep, uncompleteStep])

  return (
    <CreationGuide
      selectedPhaseType={selectedPhaseType}
      currentStep={CURRENT_STEP}
    >
      <AmenitiesSelectionGrid
        initiativeId={initiative.id}
        selectedIds={selectedIds}
        setSelectedIds={setSelectedIds}
      />
    </CreationGuide>
  )
}
